import axios from "axios";
import { APIpath } from "../App";

export const getSEO = () => axios.get(APIpath.API + '/api/seo?populate=seo.metaImage,seo.metaSocial').then(res => res.data.data.attributes.seo);